export default __webpack_public_path__ + "static/media/stock1.63dbd375.png";